import HomeRoute from '../home-module/routes';
import PageNotFoundRoute from '../page-not-found-module/routes';

export const RootRoutes = [...HomeRoute, ...PageNotFoundRoute];

export default RootRoutes;
